import { useState } from 'react';

import Globe from '@/components/icons/Globe';
import Percent from '@/components/icons/Percent';
import FixedFee from '@/components/modals/FixedFee';
import InternationalFee from '@/components/modals/InternationalFee';
import useProductStore from '@/stores/productStore';

export const PaymentTaxes = () => {
  const [openTaxes, setOpenTaxes] = useState(false);
  const [openInternationalTaxes, setOpenInternationalTaxes] = useState(false);

  const productPaymentType = useProductStore(d => d.payment.type);

  if (productPaymentType === 'free') {
    return null;
  }

  return (
    <>
      <div className='flex flex-col gap-1'>
        <a className='flex items-center text-sm underline!' id='taxes-link' onClick={() => setOpenTaxes(true)}>
          <Percent className='mr-2 h-3.5 w-3.5' />
          Entenda as taxas
        </a>

        <a
          className='flex items-center underline!'
          id='taxes-link-international'
          onClick={() => setOpenInternationalTaxes(true)}
        >
          <Globe className='mr-2 h-3.5 w-3.5' />
          Internacional
        </a>
      </div>

      <FixedFee openTaxes={openTaxes} setOpenTaxes={setOpenTaxes} />
      <InternationalFee
        openInternationalTaxes={openInternationalTaxes}
        setOpenInternationalTaxes={setOpenInternationalTaxes}
      />
    </>
  );
};
